import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class ActivityService {

  static getActivity(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getActivity}?id=${item?.id}`
      } else{
      api = `${API_BASE_URL}${API_PATHS.getActivity}?limit=${item?.limit}&page=${item?.page}`;
      }
      return axiosInstance
          .get(api)
          
  }

  
static addActivity(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addActivity}`;
    return axiosInstance
        .post(api,item)
        
}
static editActivity(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editActivity}`;
    return axiosInstance
        .put(api,item)
        
}
static deleteActivity(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deleteActivity}?id=${item?.id}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default ActivityService;